import { Button, Checkbox, FormControl, Grid, InputLabel, 
            ListItemButton, ListItemIcon, ListItemText, MenuItem,
            Select, TextField, Autocomplete, Typography, Tooltip } from '@mui/material';
import React, {useState} from 'react'
import { useFetchData } from '../../../../hooks/useFetchData/useFetchData';
import SendIcon from '@mui/icons-material/Send';
import { useShowMessages } from '../../../../hooks/useMessages/useMessages';
import { LocalizationProvider, MobileDateTimePicker, DateField } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const url = process.env.REACT_APP_API;
   

const teste = 1;



const ClientsActualizations = (props) => {
    const { data: values, loading, setLoading, editData, postData } = useFetchData((url+'/liberacao/modulos/'), {id: props.client?.id_gerente}, props.client?.id_gerente);
    
    const { data: users, load } = useFetchData( url + '/user/usergroup', { id_group: '1,2,8,11' }, true) ;
    const { ShowMessage } = useShowMessages();
    const [showCertificatePassword, setShowCertificatePassword] = useState(false);
    const [showBackupPassword, setShowBackupPassword] = useState(false);
    const [systems, setSystems] = useState([
        {
            id: 1,
            id_gerente: 1,
            name: 'Sirrus Completo - exe'
        },
        {
            id: 4,
            id_gerente: 2,
            name: 'Sirrus Ponto - exe'
        }
    ]);
    const [modules, setModules] = useState([
        {
            id: 2,
            id_gerente: 46,
            name: 'Módulo Restaurante - exe'
        },
        {
            id: 3,
            id_gerente: 19,
            name: 'Módulo PDV - exe'
        },
        {
            id: 6,
            id_gerente: '',
            name: 'Módulo Vendas - exe'
        },
        {
            id: 7,
            id_gerente: 9,
            name: 'Módulo OS Oficina - exe'
        },
        {
            id: 8,
            id_gerente: '',
            name: 'Módulo NFe/NFCe - exe'
        },
    ]);
    const [folders, setFolders] = useState([
        {
            id: 10,
            name: 'Emissão NFe - Schemas'
        },
        {
            id: 11,
            name: 'Emissão NFe - Arquivos'
        },
    ]);


    const handleChangeCheckedFolders = async (value, id) => {
        const nextFolders = folders.map((f) => {
            if (f.id === id) {
              let folder = f;
              folder.checked = value.target.checked;
              return folder;
            } else {
              return f;
            }
          });
          setFolders(nextFolders);
    };

    const handleClickShowCertificatePassword = () => {
        setShowCertificatePassword((prev) => !prev);
        };

    const handleClickShowBackupPassword = () => {
        setShowBackupPassword((prev) => !prev);
        };    

        const handleMouseDownPassword = (event) => {
        event.preventDefault(); // evita foco indesejado
        };

  return (
    <Grid container spacing={1} columns={ 12 } sx={{float: "center", minWidth: '550px'}} >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={1} marginTop={1}>
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                Sistemas e Módulos lançados  
            </Typography>
            {
              systems && systems?.filter((system) => system?.id_gerente === values?.liberacao?.sistema_id).map((system) => {
                    return <ListItemButton key={system.id}>
                                <ListItemIcon>
                                    <Checkbox 
                                        name={system.name}
                                        checked={true}
                                        inputProps={{ 'aria-label': 'controlled' }}                                                    
                                    />
                                </ListItemIcon>
                                <ListItemText primary={system.name} />
                            </ListItemButton>   
                })
            }
            {
                modules && modules?.filter((module) => values?.modulos?.find((m) => m?.id_modulo === module.id_gerente)).map((module) => {
                    if(values?.modulos?.find((m) => m?.id_modulo === module.id_gerente)){
                        return <ListItemButton key={module.id}>
                            <ListItemIcon>
                                <Checkbox 
                                    name={module.name}
                                    checked={true}
                                    inputProps={{ 'aria-label': 'controlled' }}                                                    
                                />
                            </ListItemIcon>
                            <ListItemText primary={module.name} />
                        </ListItemButton> 
                    }  
                })
            }  
            {
            values?.liberacao?.sistema_id === 1 && folders && folders?.map((folder) => {
                    return  <ListItemButton key={folder.id}>
                                <ListItemIcon>
                                    <Checkbox 
                                        name={folder.name}
                                        checked={true}
                                        onChange={(e) => handleChangeCheckedFolders(e, folder.id)}
                                        inputProps={{ 'aria-label': 'controlled' }}                                                    
                                    />
                                </ListItemIcon>
                                <ListItemText primary={folder.name} />
                            </ListItemButton> 
                })
            }                                     
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={1} marginTop={1} sx={{display: 'flex', justifyContent: 'center'}}>
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                Dados da API de Atualização Automática
            </Typography> 
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6} marginBottom={1} marginTop={1}>
              <TextField
                autoFocus
                name="contract"
                value={props.client?.contract}
                label="Usuário"
                type="text"
                fullWidth
                disabled={true}                
              />                              
        </Grid> 
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6} marginBottom={1} marginTop={1}>
              <TextField
                autoFocus
                name="contract"
                value={props.client?.cpf_cnpj}
                defaultValue=" "
                label="Senha"
                type="text"
                fullWidth
                disabled={true}                
              />                              
        </Grid> 
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6} marginBottom={1} marginTop={1}>
            <FormControl fullWidth >
            <InputLabel id="api-label">Possuí API Configurada</InputLabel>
            <Select
                labelId="api-label"
                label="Possuí API Configurada"
                name="status"
                value={props.client?.actualization_is_active}
                inputProps={{ readOnly: true }}
            >
                <MenuItem value={'N'}><em>Não</em></MenuItem>
                <MenuItem value={'Y'}><em>Sim</em></MenuItem>
            </Select>
            </FormControl>
        </Grid> 
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6} marginBottom={1} marginTop={1}>
            <FormControl fullWidth >
            <InputLabel id="api-label">Cadastrado na API</InputLabel>
            <Select
                labelId="api-label"
                label="Possuí API Configurada"
                name="status"
                value={props.client?.in_actualization_api}
                inputProps={{ readOnly: true }}
            >
                <MenuItem value={'N'}><em>Não</em></MenuItem>
                <MenuItem value={'Y'}><em>Sim</em></MenuItem>
            </Select>
            </FormControl>
        </Grid>   
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={1} marginTop={1} sx={{display: 'flex', justifyContent: 'center'}}>
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                Dados do Certificado
            </Typography> 
        </Grid>
        <Grid item xs={12} sm={12} md={12}  marginBottom={1} marginTop={1}>
              <TextField
                inputProps={{ readOnly: !props.canEditTech }}
                autoFocus
                name="certifier"
                value={props.client?.certifier}
                label="Certificadora"
                type="text"
                fullWidth     
                onChange={(e) => {
                props.setValues((prev) => ({
                ...prev,
                certifier: e.target.value
                }));    
                }}       
              />                              
        </Grid> 
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6} marginBottom={1} marginTop={1}>
              <TextField
                inputProps={{ readOnly: !props.canEditTech }}
                autoFocus
                name="certificate_password"
                value={props.client?.certificate_password}
                label="Senha do Certificado"
                type={showCertificatePassword ? 'text' : 'password'}
                fullWidth 
                onChange={(e) => {
                props.setValues((prev) => ({
                ...prev,
                certificate_password: e.target.value
                }));
                }}
                InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                    <IconButton
                        onClick={handleClickShowCertificatePassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                    >
                        
                        {showCertificatePassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                    
                    </InputAdornment>
                ),
                }}          
              />                              
        </Grid> 
        <Grid item xs={3} md={3}  marginBottom={1} marginTop={1}>
            <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
                <DateField 
                disabled={!props.canEditTech}
                fullWidth
                sx={{ width: '100%' }}
                label="Início"
                ampm={false}
                name="certificate_start"
                value={props.client?.certificate_start ? dayjs(props.client.certificate_start) : null}
                onChange={(newValue) => {
                    props.setValues((prev) => ({
                    ...prev,
                    certificate_start: newValue?.isValid() ? newValue.format('YYYY-MM-DD') : null
                    }));
                }}
                format="DD/MM/YYYY"
                />
            </LocalizationProvider>                            
        </Grid> 
       <Grid item xs={3} md={3}  marginBottom={1} marginTop={1}>
            <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
                <DateField 
                disabled={!props.canEditTech}
                fullWidth
                sx={{ width: '100%' }}
                label="Vencimento"
                ampm={false}
                name="certificate_end"
                value={props.client?.certificate_end ? dayjs(props.client.certificate_end) : null}
                onChange={(newValue) => {
                    props.setValues((prev) => ({
                    ...prev,
                    certificate_end: newValue?.isValid() ? newValue.format('YYYY-MM-DD') : null
                    }));
                }}
                format="DD/MM/YYYY"
                />
            </LocalizationProvider>                            
        </Grid> 
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={1} marginTop={1} sx={{display: 'flex', justifyContent: 'center'}}>
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                Dados do Backup Automático
            </Typography> 
        </Grid>
        <Grid item xs={12} sm={12} md={12} marginBottom={1} marginTop={1} >
            <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
            <MobileDateTimePicker 
                fullWidth
                sx={{width: '100%'}}
                label={'Data do último backup'} 
                ampm={false} 
                openTo="day" 
                name="data_last_bkp"
                value={dayjs.tz(props.client?.data_last_bkp)}
                disabled={true}
                format="DD/MM/YYYY HH:mm" 
                />
            </LocalizationProvider>
        </Grid>
        
        <Grid item xs={12} sm={6} md={6}  marginBottom={1} marginTop={1}>
            <Tooltip
             title="Informe o e-mail usado para autenticação do backup"
                arrow
                componentsProps={{
                    tooltip: {
                    sx: {
                        backgroundColor: '#333',
                        color: 'white',
                        fontSize: '0.9rem',
                        padding: '8px 12px',
                        borderRadius: 2,
                        boxShadow: 3,
                        maxWidth: 220,
                    },
                    },
                    arrow: {
                    sx: {
                        color: '#333',
                    },
                    },
                }}>
              <TextField
                inputProps={{ readOnly: !props.canEditTech }}
                autoFocus
                name="bkp_user"
                value={props.client?.bkp_user}
                label="Usuário do Backup"
                type="text"
                fullWidth 
                onChange={(e) => {
                props.setValues((prev) => ({
                ...prev,
                bkp_user: e.target.value
                }));
            }}            
              />
              </Tooltip>                              
        </Grid>
        <Grid item xs={12} sm={6} md={6}  marginBottom={1} marginTop={1}>
            <FormControl fullWidth >
            <InputLabel id="bkp-label">Modo Backup</InputLabel>
            <Select
                labelId="bkp-label"
                label="Status"
                name="status"
                value={props.client?.type_bkp}
                inputProps={{ readOnly: true }}
            >
                <MenuItem value={''}><em>Não Informado</em></MenuItem>
                <MenuItem value={0}><em>API Backup</em></MenuItem>
                <MenuItem value={1}><em>Dropbox</em></MenuItem>
            </Select>
            </FormControl>
        </Grid>  
        <Grid item xs={12} sm={6} md={6} marginBottom={1} marginTop={1}>
            <Tooltip
             title="Informe a senha necessária para realizar a autenticação do backup"
                arrow
                componentsProps={{
                    tooltip: {
                    sx: {
                        backgroundColor: '#333',
                        color: 'white',
                        fontSize: '0.9rem',
                        padding: '8px 12px',
                        borderRadius: 2,
                        boxShadow: 3,
                        maxWidth: 220,
                    },
                    },
                    arrow: {
                    sx: {
                        color: '#333',
                    },
                    },
                }}>
        <TextField
            inputProps={{ readOnly: !props.canEditTech }}
            autoFocus
            name="bkp_password"
            label="Senha do Backup"
            type={showBackupPassword ? 'text' : 'password'}
            value={props.client?.bkp_password}
            fullWidth
            onChange={(e) => {
                props.setValues((prev) => ({
                ...prev,
                bkp_password: e.target.value
                }));
            }}
            InputProps={{
            endAdornment: (
                <InputAdornment position="end">
                <IconButton
                    onClick={handleClickShowBackupPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                >
                    
                    {showBackupPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
                
                </InputAdornment>
            ),
            }}
        />
        </Tooltip>
        </Grid>
        <Grid item xs={12} sm={6} md={6}  marginBottom={1} marginTop={1}>
            <Tooltip
             title="Informe os nomes dos clientes responsáveis e/ou presentes na configuração do backup da empresa"
                arrow
                componentsProps={{
                    tooltip: {
                    sx: {
                        backgroundColor: '#333',
                        color: 'white',
                        fontSize: '0.9rem',
                        padding: '8px 12px',
                        borderRadius: 2,
                        boxShadow: 3,
                        maxWidth: 220,
                    },
                    },
                    arrow: {
                    sx: {
                        color: '#333',
                    },
                    },
                }}>
              <TextField
                inputProps={{ readOnly: !props.canEditTech }}
                autoFocus
                name="bkp_responsibles"
                value={props.client?.bkp_responsibles}
                label="Responsáveis pelo Backup"
                type="text"
                fullWidth
                onChange={(e) => {
                props.setValues((prev) => ({
                ...prev,
                bkp_responsibles: e.target.value
                }));
            }}    
              />   
              </Tooltip>                           
        </Grid>
        <Grid item xs={12} sm={6} md={6} marginBottom={1} marginTop={1}>
        <Autocomplete
            disabled={!props.canEditTech}
            options={users}
            getOptionLabel={(option) => option.name}
            value={users.find((u) => u.name === props.client?.bkp_technician) || null}
            onChange={(event, value) => {
                props.setValues((prev) => ({
                ...prev,
                bkp_technician: value?.name || '',
                }));
            }}
            renderInput={(params) => (
                <TextField
                 {...params} 
                 label="Técnico que configurou o backup" 
                fullWidth  />
            )}
            disableClearable
            popupIcon={null}
            ListboxProps={{ style: { maxHeight: 250 } }}
            />
            </Grid>
        <Grid item xs={12} sm={6} md={6} marginBottom={1} marginTop={1} >
            <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
            <MobileDateTimePicker 
            disabled={!props.canEditTech}
            label="Data de Configuração do Backup"
            ampm={false}
            value={props.client?.bkp_config_date ? dayjs(props.client.bkp_config_date) : null}
            onChange={(newValue) => {
                props.setValues((prev) => ({
                ...prev,
                bkp_config_date: newValue?.isValid() ? newValue.format('YYYY-MM-DD HH:mm:ss') : null
                }));
            }}
            format="DD/MM/YYYY HH:mm"
            sx={{ width: '100%' }}
            />
            </LocalizationProvider>
        </Grid>
    
    </Grid> 
  )
}

export default ClientsActualizations;